import React, { useState, useEffect } from 'react';
import styles from './AddPaymentModeForm.module.css';

interface AddPaymentModeFormProps {
  onSubmit: (formData: PaymentModeFormData) => void;
  onCancel: () => void;
  initialData?: Partial<PaymentModeFormData>;
}

export interface PaymentModeFormData {
  name: string;
  type: string;
  status: string;
}

const AddPaymentModeForm: React.FC<AddPaymentModeFormProps> = ({ onSubmit, onCancel, initialData }) => {
  const [formData, setFormData] = useState<PaymentModeFormData>({
    name: '',
    type: '1',
    status: 'Active',
  });

  // Populate form with initial data when editing
  useEffect(() => {
    if (initialData) {
      setFormData((prev) => ({
        ...prev,
        ...initialData,
      }));
    }
  }, [initialData]);

  const handleChange = (e: React.ChangeEvent<HTMLInputElement | HTMLSelectElement>) => {
    const { name, value } = e.target;
    setFormData((prev) => ({
      ...prev,
      [name]: value,
    }));
  };

  const handleSubmit = (e: React.FormEvent) => {
    e.preventDefault();
    onSubmit(formData);
  };

  return (
    <form onSubmit={handleSubmit} className={styles.form}>
      <div className={styles.field}>
        <label htmlFor="name" className={styles.label}>
          Name <span className={styles.required}>*</span>
        </label>
        <input
          type="text"
          id="name"
          name="name"
          value={formData.name}
          onChange={handleChange}
          className={styles.input}
          required
        />
      </div>

      <div className={styles.field}>
        <label htmlFor="type" className={styles.label}>
          Type <span className={styles.required}>*</span>
        </label>
        <select
          id="type"
          name="type"
          value={formData.type}
          onChange={handleChange}
          className={styles.select}
          required
        >
          <option value="1">Cash</option>
          <option value="2">Bank</option>
          <option value="3">UPI</option>
          <option value="4">QR Code</option>
          <option value="5">Wallet</option>
        </select>
      </div>

      <div className={styles.field}>
        <label htmlFor="status" className={styles.label}>
          Status
        </label>
        <select
          id="status"
          name="status"
          value={formData.status}
          onChange={handleChange}
          className={styles.select}
        >
          <option value="Active">Active</option>
          <option value="Inactive">Inactive</option>
        </select>
      </div>

      <div className={styles.actions}>
        <button type="button" onClick={onCancel} className={styles.cancelButton}>
          Cancel
        </button>
        <button type="submit" className={styles.submitButton}>
          {initialData ? 'Update' : 'Create'}
        </button>
      </div>
    </form>
  );
};

export default AddPaymentModeForm;
